import CELL_DATA_TYPES from '../cell-types.config';
import { ACTIONS } from '../const.config';

// Email Templates module configurations
export const LISTING_COLUMNS = [
  {
    id: 'title',
    label: 'Title',
    width: '20%',
    align: 'left',
    dataKey: 'title',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'sendOnAction',
    label: 'Trigger Action',
    width: '20%',
    align: 'left',
    dataKey: 'sendOnAction',
    sortable: false,
    type: CELL_DATA_TYPES.EMAIL_SEND_ACTION,
  },
  {
    id: 'status',
    label: 'Status',
    width: '10%',
    align: 'center',
    dataKey: 'status',
    sortable: true,
    type: CELL_DATA_TYPES.SWITCH,
  },
  {
    id: 'createdAt',
    label: 'Created',
    width: '15%',
    align: 'left',
    dataKey: 'createdAt',
    sortable: true,
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
];

export const LISTING_ACTIONS = [
  {
    action: ACTIONS.EDIT.value,
    label: ACTIONS.EDIT.label,
  },
  {
    action: ACTIONS.VIEW.value,
    label: ACTIONS.VIEW.label,
  },
  {
    action: ACTIONS.DELETE.value,
    label: ACTIONS.DELETE.label,
  },
];

export const VIEW_COLUMNS = [
  {
    id: 'title',
    label: 'Title',
    dataKey: 'title',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'sendOnAction',
    label: 'Trigger Action',
    dataKey: 'sendOnAction',
    type: CELL_DATA_TYPES.EMAIL_SEND_ACTION,
  },
  {
    id: 'mailSubject',
    label: 'Subject',
    dataKey: 'mailSubject',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'mailContent',
    label: 'Content',
    dataKey: 'mailContent',
    type: CELL_DATA_TYPES.HTML,
  },
  {
    id: 'status',
    label: 'Status',
    dataKey: 'status',
    type: CELL_DATA_TYPES.STATUS,
  },
  {
    id: 'createdAt',
    label: 'Created At',
    dataKey: 'createdAt',
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
];
